<template>
  <RevCheckbox
    id="gift-checkbox"
    v-model="isGift"
    class="mb-24 mt-16 w-full md:max-w-320"
    :image="IconGift"
    :image-props="{ alt: '' }"
    variant="full"
    @update:model-value="handleToggle"
  >
    <template #label>
      {{ i18n(translations.label) }}
    </template>
  </RevCheckbox>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevCheckbox } from '@ds/components/Checkbox'
import { IconGift } from '@ds/icons/IconGift'

import translations from './GiftCheckbox.translations'

const i18n = useI18n()
const { trackClick } = useTracking()

const props = defineProps<{
  orderId?: number
}>()

const isGift = ref(false)

function handleToggle(checked: boolean | string[]) {
  if (typeof checked === 'boolean') {
    trackClick({
      name: checked ? 'is_gift_ticked' : 'is_gift_unticked',
      zone: 'checkout_payment_result',
      value: props.orderId ?? '',
    })
  }
}
</script>
